import { useState } from 'react';
import styles from './index.module.scss';
import InviteTemplate from '../invite-template';
import ViewSelector, { ViewOption } from './view-selector.component';
import { IEmailTemplateFormValues } from '../../../../../common/validations/email-templates.validations';
import DeviceDimension from './device-dimension.component';
import { ReactElement } from 'react';

interface ModalBodyProps<T extends IEmailTemplateFormValues> {
  formValues: T;
  previewComponent: (formValues: T) => ReactElement;
}

const ModalBody = <T extends IEmailTemplateFormValues>({ formValues, previewComponent }: ModalBodyProps<T>) => {
  const [activeView, setActiveView] = useState<ViewOption>(ViewOption.DESKTOP);
  const [mobileWidth, setMobileWidth] = useState<number>(393);
  const [containerHeight, setContainerHeight] = useState<number>(0);

  const previewWidth = activeView === ViewOption.DESKTOP ? 596 : mobileWidth;

  return (
    <div className={styles.modalBody}>
      <ViewSelector activeView={activeView} setActiveView={setActiveView} />
      {activeView === ViewOption.MOBILE && (
        <DeviceDimension 
          width={mobileWidth} 
          onWidthChange={setMobileWidth}
          height={containerHeight}
        />
      )}
      <InviteTemplate 
        formValues={formValues} 
        width={previewWidth}
        onHeightChange={setContainerHeight}
        isMobileView={activeView === ViewOption.MOBILE}
        previewComponent={previewComponent}
      />
    </div>
  );
};

export default ModalBody;
